// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import './services/something'
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap'
import BootstrapVue from 'bootstrap-vue'
import Default from './layouts/Default'
import WithSideBar from './layouts/WithSideBar'
import Notifications from 'vue-notification'
import Loader from './services/LoaderOverlay'
import './registerServiceWorker'
import Vue2Filters from 'vue2-filters'
import './common/formatNumber.filter'
import './directives/aimSort.directive'
import VueMoment from 'vue-moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import EfishDataService from '@/services/EfishDataService'

export const breadcrumbEventBus = new Vue()
export const spinnerEventBus = new Vue()

Vue.use(BootstrapVue)
Vue.use(Notifications)
Vue.use(Loader)
Vue.use(VueMoment)
Vue.use(Vue2Filters)
Vue.use(VueAxios, axios)
// hard refresh performed, clear all cache
EfishDataService.clearAll()

// register global component
Vue.component('default-layout', Default)
Vue.component('with-sidebar-layout', WithSideBar)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})
